import React from 'react';
import cls from './UsersListHeader.module.scss';

const UsersListHeader = () => {
  return (
    <ul className={cls.ListHeader} data-testid="users-list">
      <li className={cls.ListItem} id="name">
        <span>Name</span>
      </li>
      <li className={cls.ListItem} id="email">
        <span>Email</span>
      </li>
      <li className={cls.ListItem} id="phone">
        <span>Phone</span>
      </li>
      <li className={cls.ListItem} id="role">
        <span>Role</span>
      </li>
      <li className={cls.ListItem}>
        <span>Status</span>
      </li>
    </ul>
  );
};

export default UsersListHeader;
